export default function setPayment(e) {
    const cHiddenMonthsPayment = document.querySelector(".calc-hidden-months-payment")

    e = e.replace(" ", ""),
    e = e.replace(".", ""),
    e = e.replace(",-", ""),
    e = e.replace(":-", ""),
    e = e.replace("kr.", ""),
    e = e.replace(" ", ""),
    cHiddenMonthsPayment.value = e;
}